import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	function navigation(slider) {
		let navWrapper = document.querySelector('.testimonials .keen-navigation')
		let arrowLeft = document.querySelector(
			'.testimonials .keen-navigation .arrow--left'
		)
		let arrowRight = document.querySelector(
			'.testimonials .keen-navigation .arrow--right'
		)

		slider.on('created', () => {
			arrowLeft.addEventListener('click', () => slider.prev())
			arrowRight.addEventListener('click', () => slider.next())
		})
	}

	var slider = new KeenSlider(
		'.testimonials .keen-slider',
		{
			breakpoints: {
				'(min-width: 48rem)': {
					slides: {
						perView: 1.25,
						spacing: 24,
					},
				},
				'(min-width: 75rem)': {
					slides: {
						perView: 1.25,
						spacing: 32,
					},
				},
				'(min-width: 96rem)': {
					slides: {
						perView: 1.5,
						spacing: 32,
					},
				},
			},
			slides: {
				perView: 1.05,
				spacing: 24,
			},
			loop: true,
		},
		[navigation]
	)
})
